import React from "react";
import DOMPurify from 'dompurify';

const SafeHtml = ({ html, allowed_tags=[], allowed_attrs=[] }) => {
  const sanitized = DOMPurify.sanitize(html, {
    ALLOWED_TAGS: [...['b', 'i', 'u', 'br', 'ul', 'li'], ...allowed_tags],
    ALLOWED_ATTR: allowed_attrs
  });

  return <div dangerouslySetInnerHTML={{ __html: sanitized }} />;
};

export default SafeHtml;